import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { v4 as uuidv4 } from 'uuid';
import { saveAs } from 'file-saver';
import { notificationInit } from '../../modules/notifications/actions';
import { REQUEST_ERROR_MESSAGE } from './constants';
import { getAddressesRequest, getBlobForReqListRequest } from '../../api/requests';
import { getPartnerAddressesRequest } from '../../api/partners-requests';
import {
	GET_ADDRESSES,
	GET_PARTNER_ADDRESSES,
	GET_LIST_ADDRESS_FILE_TYPES,
	setAddressesAction,
	setIsAddressesLoadingAction,
	setPaginationAction,
	setIsDownloadLoadingAction,
} from './actions';
import { DISMISS_TIME } from '../../api/constants';
import { errorHandler } from '../../api/utils';
import { removeModalQuery } from '../../utils/removeModalQuery';

export function* getAddressesSaga({ payload: { searchQuery, noLoading } }) {
	try {
		if (!noLoading) {
			yield put(setIsAddressesLoadingAction(true));
		}

		const { data, message, meta, toast } = yield call(getAddressesRequest, searchQuery);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			const query = new URLSearchParams(searchQuery);
			query.delete('modal');
			query.delete('mode');
			query.delete('id');

			yield put(
				setAddressesAction(
					data?.map(address => ({
						...address,
						link: `?${query ? `${query}&` : ''}modal=address&id=${address.id}`,
						marker: `https://yandex.ru/maps/?pt=${address.geo_lon},${address.geo_lat}&z=18&l=map`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsAddressesLoadingAction(false));
	}
}

export function* getPartnerAddressesSaga({ payload: { searchQuery, id } }) {
	try {
		yield put(setIsAddressesLoadingAction(true));

		const query = new URLSearchParams(searchQuery);
		query.delete('filters');
		query.delete('sorts');

		const str = removeModalQuery(
			query.toString().replace('modalSorts', 'sorts').replace('modalFilters', 'filters'),
		);

		const { data, message, meta, toast } = yield call(
			getPartnerAddressesRequest,
			`${str ? `${str}&receive=all` : '?receive=all'}`,
			id,
		);

		if (data) {
			if (toast) {
				yield put(notificationInit({ id: uuidv4(), dismissAfter: DISMISS_TIME, ...toast }));
			}

			const query = new URLSearchParams(searchQuery);
			query.delete('modal');

			yield put(
				setAddressesAction(
					data?.map(address => ({
						...address,
						link: `?${query ? `${query}&` : ''}modal=address&addressId=${address.id}`,
						marker: `https://yandex.ru/maps/?pt=${address.geo_lon},${address.geo_lat}&z=18&l=map`,
					})),
				),
			);

			if (meta) {
				yield put(
					setPaginationAction({
						current_page: meta.current_page,
						per_page: meta.per_page,
						from: meta.from,
						last_page: meta.last_page,
						total: meta.total,
					}),
				);
			}
		} else {
			throw new Error(message || REQUEST_ERROR_MESSAGE);
		}
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsAddressesLoadingAction(false));
	}
}

export function* getReqListFileSaga({ payload: { exportUrl } }) {
	try {
		yield put(setIsDownloadLoadingAction(true));

		const blob = yield call(getBlobForReqListRequest, exportUrl);

		saveAs(blob, 'addresses.xlsx');
	} catch (error) {
		yield fork(errorHandler, error);
	} finally {
		yield put(setIsDownloadLoadingAction(false));
	}
}

export default function* addressesSaga() {
	yield takeEvery(GET_ADDRESSES, getAddressesSaga);
	yield takeEvery(GET_PARTNER_ADDRESSES, getPartnerAddressesSaga);
	yield takeEvery(GET_LIST_ADDRESS_FILE_TYPES, getReqListFileSaga);
}
